import get from 'lodash.get';

const getPageTemplates = (rootState) => get(rootState, 'ws.template.meta.pageTemplates', []);

export default getPageTemplates;
